import Button from "@ey-xd/motif-react/components/button";
import React, { useState } from "react";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import { useSelector } from "react-redux";

const ReportDocPreview = (props: any) => {
    const {aiGeneratedOutput, historicalOutput, fileType} = props;
    const [activeIndex, setActiveIndex] = useState(0);
    if(!aiGeneratedOutput) {
        return <p>loading document...</p>
    }
    return (
        <div className="flex justify-between">
            {/* <div className="flex gap-3 mb-3">
            <Button variant={activeIndex === 0 ? "primary" : "secondary"}  onClick={() => setActiveIndex(0)}>AI Generated PPT</Button>
            <Button variant={activeIndex === 1 ? "primary" : "secondary"} onClick={() => setActiveIndex(1)}>Historical Reponse</Button>
            </div> */}
            {/* {
                activeIndex === 0 ? ( */}
                <div className="w-[49.5%] border">
                    <DocViewer
                    style={{height: "70vh"}}
                    pluginRenderers={DocViewerRenderers}
                    documents={[{ uri: aiGeneratedOutput, fileType}]} />
                </div>        
                {/* ) : ( */}
                <div className="w-[49.5%] border">
                    <DocViewer
                    style={{height: "70vh"}}
                    pluginRenderers={DocViewerRenderers}
                    documents={[{ uri: historicalOutput, fileType}]} />  
                </div>
                {/* ) */}
        {/* } */}
        </div>
    )
}

export default ReportDocPreview;